<template>
  <div class="tableContainer">
    <table>
      <tr>
        <th>设备名称</th>
        <th>货道号</th>
        <th>货道状态</th>
        <th>库存数量</th>
        <th>库存状态</th>
        <th>销量</th>
        <th>退款数</th>
        <th>退款率</th>
        <th>合计</th>
      </tr>
      <tbody v-for="(item,index) in displayedData" :key="index">
      <tr>
        <td :rowspan="item.children.length" :style="{width: '30%'}">{{ item.device }}</td>
        <td>{{item.children[0].road}}</td>
        <td :class="item.children[0].status === 'open'?'green':'red'">
          {{ item.children[0].status | statusFilter }}
          <i :class="item.children[0].status === 'open'? 'el-icon-circle-check' : 'el-icon-circle-close'"></i>
        </td>
        <td>{{ item.children[0].surplus_num }}</td>
        <td>{{ item.children[0].surplus_status }}</td>
        <td >{{ item.children[0].sale }}</td>
        <td >{{ item.children[0].refund }}</td>
        <td >{{ item.children[0].compare }}</td>
        <td :rowspan="item.children.length">
          <p>实际销量：{{item.total}}</p>
          <p>退款数：{{item.refund}}</p>
          <p>退款率：{{item.rate}}</p>
        </td>
      </tr>
      <tr v-for="(inner,index1) in item.children.slice(1)" :key="index1">
        <td >{{ inner.road }}</td>
        <td :class="inner.status === 'open'?'green':'red'">
          {{ inner.status | statusFilter }}
          <i :class="inner.status === 'open'? 'el-icon-circle-check' : 'el-icon-circle-close'"></i>
        </td>
        <td>{{ inner.surplus_num }}</td>
        <td>{{ inner.surplus_status }}</td>
        <td >{{ inner.sale }}</td>
        <td >{{ inner.refund }}</td>
        <td >{{ inner.compare }}</td>
      </tr>
      </tbody>

    </table>

    <!-- 分页器 -->
    <el-pagination
        background
        :layout="layout"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[3, 10, 20, 30]"
        :page-size="pageSize"
        :total="tableData.length"
    />

  </div>
</template>

<script>
import { getDeviceQuota } from "@/api/bi";

export default {
  name: "QuotaTable",
  mounted() {
    this.fetchData();
  },
  props:['params'],
  data(){
    return {
      tableData: [],
      currentPage: 1,    // 当前页码
      pageSize: 3,       // 每页显示条数
      layout: 'total, sizes, prev, pager, next, jumper', // 分页数据
    }
  },
  filters: {
    statusFilter(val){
      if(val === 'open'){
        return '开启'
      } else {
        return '关闭'
      }
    }
  },
  methods: {
    fetchData(){
      // 页码重置为第一页
      this.currentPage = 1;
      // params是父组件传递过来的参考
      getDeviceQuota(this.params).then(res => {
        if(res && res.code === 2000 && res.data) {
          this.tableData = res.data;
        } else {
        }
      })

    },
    // 处理每页条数变化
    handleSizeChange(val) {
      this.pageSize = val;
    },
    // 处理当前页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
    }
  },
  computed:{
    // 计算属性，根据当前页和每页条数获取当前显示的数据
    displayedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      // 此处判断一下data是不是{}
      if(this.tableData && this.tableData.length > 0) {
        return this.tableData.slice(start, end);
      } else {
        return []
      }

    }
  }
}
</script>

<style scoped>
.tableContainer {
  /*height: 400px;*/
  /*overflow-y: auto;*/
  margin-bottom: 50px;
  border: 1px solid #fff;
}

table {
  width: 100%;
}
td, th {
  border-bottom: 1px solid #ccc;
  text-align: center;
  padding: 10px 0;
}

td.green {
  color: #8ce78c;
}

td.red {
  color: #f36161;
}

tr th:nth-child(1){
  width: 30%;
}
</style>